import api from "./api";

export default class ExtratoApi {
  static getExtractPerClient = async (
    page: Number,
    RecordsPerPage: Number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static getExtractList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number,
    filtroSaldo: string
  ) => {
    const response = await api.get(
      `/Extrato/listagem?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}&filtroSaldo=${filtroSaldo}`
    );
    return response;
  };

  static getExtractFutureReleasesList = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Extrato?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&lancamentosFuturos=${true}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static getSaldoVendas = async (
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas/${idCliente}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response;
  };

  static postLancamento = async (obj: any) => {
    const response = await api.post(`/Extrato`, obj);
    return response.data;
  };

  static getFutureSaldo = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    idCliente: number
  ) => {
    const response = await api.get(
      `/Saldo/vendas-futuras?Page=${page}&RecordsPerPage=${RecordsPerPage}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`
    );
    return response;
  };

  static exportFile = async (
    dataInicio: any,
    dataFim: any,
    id: any,
    search: string,
    ModoPgto: any,
    idStatus: any
  ) => {
    const response = await api.get(
      `/Transacao/download?dataInicio=${dataInicio}&dataFim=${dataFim}&Search=${search}&idCliente=${id}&ModoPgto=${ModoPgto}&idStatus=${idStatus}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static exportExtract = async (
    page: number,
    RecordsPerPage: number,
    dataInicio: any,
    dataFim: any,
    id: any,
    filtroSaldo: string,
    future: boolean
  ) => {
    const response = await api.get(
      `/Extrato/download/detalhado/cliente?Page=${page}&RecordsPerPage=${RecordsPerPage}&filtroSaldo=${filtroSaldo}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${id}&futuro=${future}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static getSaldoBandeira = async (dataInicio: any, dataFim: any, id: any) => {
    const response = await api.get(
      `/Saldo/bandeira/${id}?dataInicio=${dataInicio}&dataFim=${dataFim}`
    );
    return response.data;
  };
}
